import { AjaxService } from "../Helpers/AjaxService";
import { LocalStorageCache, GlobalCacheKeys } from "../Helpers/LocalStorageCache";


export class TermsApi {
    private static instance: TermsApi;
    static getInstance() { return TermsApi.instance || (TermsApi.instance = new TermsApi()); }

    getAccpetedTerms(): Promise<boolean> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/api/Terms/GetAcceptedTerms`;
        
        return new Promise<boolean>((resolve) => {
            ajaxService.get(apiUrl, (result: boolean) => {
                resolve(result);
            });
        });
    }

    postAcceptedTerm(): Promise<void> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = "api/Terms/SetAcceptedTerms";
        return new Promise<void>((resolve) => {
            ajaxService.post(apiUrl, () => resolve());
        }); 
    }
}